import { Injectable } from '@angular/core';
import { Model, ModelFactory } from '@angular-extensions/model';
import { Observable } from 'rxjs';
import { ErrorModel } from '../models/error.model';

const initialData: ErrorModel[] = [];


@Injectable({
    providedIn: 'root'
})
export class ErrorService {
  private model: Model<ErrorModel[]>;

  errors$: Observable<ErrorModel[]>;

  constructor(private modelFactory: ModelFactory<ErrorModel[]>) {
    this.model = this.modelFactory.create(initialData);
    this.errors$ = this.model.data$;
  }

  addError(error: ErrorModel) {
    const errors = this.model.get();

    errors.push(error);
    this.model.set(errors);
  }

  clear() {
    this.model.set([]);
  }
}
